import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Index, useHits } from 'react-instantsearch';

import getConfig from '@/configs/global';

const {
  publicRuntimeConfig: { NEXT_PUBLIC_ALGOLIA_CATEGORIES_INDEX_NAME },
} = getConfig();

function CategoryReporter({ onResults }) {
  const { items } = useHits();
  useEffect(() => {
    onResults(items);
  }, [items, onResults]);
  return null;
}

CategoryReporter.propTypes = {
  onResults: PropTypes.func.isRequired,
};

export default function CategorySearch({ onResults }) {
  if (!NEXT_PUBLIC_ALGOLIA_CATEGORIES_INDEX_NAME) return null;
  return (
    <Index indexName={NEXT_PUBLIC_ALGOLIA_CATEGORIES_INDEX_NAME}>
      <CategoryReporter onResults={onResults} />
    </Index>
  );
}

CategorySearch.propTypes = {
  onResults: PropTypes.func.isRequired,
};
